import styled from "styled-components";
import theme from "../../theme/theme";
import exp from "constants";

export const ProfileWrapper = styled.div`
  padding: 0 10%;
  // background: linear-gradient(180deg, #011740, #FFFFFF 50%);
  @media (max-width: 400px) {
    padding: 0 2% 8% 2%;
  }
`;

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: row;
  // height: 60vh;
  margin-bottom: 8%;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 0 5% 2% 5%;
    gap: 30px;
  }

  @media (max-width: 400px) {
    padding: 0 2%;
    gap: 10px;
  }
`;

export const LeftWrapper = styled.div`
  justify-content: center;
  margin: auto 10% auto 7%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  width: 40%;

  @media (max-width: 768px) {
    margin: 20px auto;
    width: 100%;
  }
`;

export const RightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 60%;
  @media (max-width: 768px) {
    width: 100%;
    align-items: center;
  }
`;

export const Title = styled.h1`
  font-family: "Inter", sans-serif;
  font-size: 55px;
  margin: 0;
  font-weight: 800;
  padding-top: 50px;
  margin-bottom: 15px;
  color: ${theme.color.navy};
  @media (max-width: 420px) {
    font-size: 40px;
    padding-top: 30px;
  }
`;

export const HeaderWrapper = styled.div`
  @media (max-width: 400px) {
    margin-left: 20px;
  }
`;

export const ToggleButtonWrapper = styled.div`
  margin: 20px auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  @media (max-width: 640px) {
    margin-top: 50px;
  }
`;

export const Label = styled.label`
  position: relative;
  display: inline-block;
  width: 62px;
  height: 30px;
  line-height: 30px;
  user-select: none;
`;

export const Input = styled.input`
  display: none;
`;

export const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: -3px;
  left: -1px;
  right: 1px;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 30px;

  &:before {
    content: "";
    position: absolute;
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
    display: block;
  }

  ${Input}:checked + & {
    background-color: ${theme.color.navy};
  }

  ${Input}:checked + &:before {
    transform: translateX(100%);
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  justify-content: fle;
  align-items: center;
`;

export const Text = styled.p`
  margin: 5px 0 0;
  color: ${theme.color.black};
  font-size: 18px;
`;

export const TextBold = styled.p`
  margin: 5px 0 0;
  color: ${theme.color.navy};
  font-size: 20px;
  font-weight: 600;
  font-style: italic;
`;

export const UserTypeContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: ${theme.color.white};
  border-radius: 10px;
  gap: 20px;
  width: 100%;
  padding: 0 10px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  @media (max-width: 400px) {
    width: 96%;
  }
`;

export const UserTypeText = styled.p`
  margin: 5px 0 0;
  color: ${theme.color.stone};
  font-size: 18px;
  font-weight: 400;
  margin: 0;
  @media (max-width: 400px) {
    font-size: 16px;
  }
`;

export const UserTypeTextBold = styled.p`
  margin: 5px 0 0;
  color: ${theme.color.black};
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  @media (max-width: 400px) {
    font-size: 16px;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  background-color: ${theme.color.apricot}
  border-radius: 10px;
`;

export const SwitchContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-left: auto;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10px;
`;
